import { render, staticRenderFns } from "./BaseNavBar.vue?vue&type=template&id=47104074"
import script from "./BaseNavBar.vue?vue&type=script&lang=js"
export * from "./BaseNavBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports